import axios from 'axios';

export async function getIPAddress() {
  try {
    const response = await axios.get('https://api.ipify.org?format=json');
    return response.data.ip; 
  } catch (error) {
    console.error('Erro ao obter o endereço IP:', error);
    return null;
  }
}